'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _liveElement = require('./live-element');

var _decko = require('decko');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Observable = (_class = function () {

  /**
   * Creates an instance of LiveElement.
   *
   * @param {string}      selector
   * @param {HTMLElement} parent
   */


  /**
   * List Events
   *
   * @type {object}
   */


  /**
   * The CSS selector used to collect items
   *
   * @type string
   */

  /**
   * A store of eventListener callbacks which will be attached to the item
   *
   * @type {object}
   */
  function Observable(selector) {
    var _this = this;

    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Observable);

    this.eventListeners = {};
    this.observerConfig = {
      attributes: false,
      characterData: false,
      childList: true,
      subtree: true };
    this.selector = '';
    this.parent = document.documentElement;
    this.events = {
      update: [],
      start: [],
      pause: [],
      resume: [],
      'eventListeners:add': [],
      'eventListeners:remove': [],
      'eventListeners:attach': [],
      'eventListeners:detach': [],
      'eventListeners:purge': [],
      'delegatedEventListeners:add': [],
      'delegatedEventListeners:remove': [],
      'delegatedEventListeners:attach': [],
      'delegatedEventListeners:detach': [],
      'delegatedEventListeners:purge': []

      /**
       * Delegated list events
       *
       * @type {object}
       */
    };
    this.delegatedEvents = {};

    this.selector = selector;

    this.observerConfig = _extends({}, this.observerConfig, config);

    if (parent instanceof this.constructor) {
      this.parent = parent.item;
      parent.on('update', function (newItem, oldItem) {
        _this.pause();
        _this.parent = newItem;
        _this.resume();
        _this.refresh();
      });
    } else {
      this.parent = parent;
    }
  }

  /**
   * Add an event listener which will apply to the LiveElement
   *
   * @param {string} event
   * @param {function} callback
   *
   * @return {LiveElement}
   */


  /**
   * The parent element of the underlying element
   *
   * @type {HTMLElement}
   */


  /**
   * Configuration to pass to elements observed by mutation observer
   *
   * @type {object}
   */


  _createClass(Observable, [{
    key: 'on',
    value: function on(event, callback) {
      if (typeof callback !== 'function') {
        throw new TypeError('callback must be a function');
      }

      this.events[event].push(callback);

      return this;
    }

    /**
     * Remove an event listener from the LiveElement itself
     *
     * @param {string} event
     * @param {function} callback
     *
     * @return {LiveElement}
     */

  }, {
    key: 'off',
    value: function off(event, callback) {
      if (typeof callback !== 'function') {
        throw new TypeError('callback must be a function');
      }

      if (event in this.events) {
        var i = this.events[event].indexOf(callback);
        if (i > -1) {
          this.events[event].splice(i, 1);
        }
      }

      return this;
    }

    /**
     * Detach event listeners from all items, and clear the list of listeners
     */

  }, {
    key: 'purgeEventListeners',
    value: function purgeEventListeners() {
      this.detachEventListeners();
      this.eventListeners = {};

      this.events['eventListeners:purge'].forEach(function (callback) {
        return callback();
      });
    }

    /**
     * Add an event listener to another element, which will be removed when the
     * list is empty
     *
     * @param {HTMLElement} target
     * @param {string}      event
     * @param {function}    callback
     */

  }, {
    key: 'addDelegatedEventListener',
    value: function addDelegatedEventListener(target, event, callback, options) {
      if (typeof callback !== 'function') {
        throw new TypeError('callback must be a function');
      }

      if (!(target instanceof Element || target instanceof Window || target instanceof HTMLDocument)) {
        throw new TypeError('target must be window, document or an element');
      }

      if (!(event in this.delegatedEvents)) {
        this.delegatedEvents[event] = [];
      }

      this.delegatedEvents[event].push({ target: target, callback: callback, options: options });

      if ('items' in this && this.items.length > 0 || 'item' in this && this.item) {
        target.addEventListener(event, callback, options);
      }

      this.events['delegatedEventListeners:add'].forEach(function (callback) {
        return callback();
      });
    }

    /**
     * Remove a delegated event listener from another element
     *
     * @param {HTMLElement} target
     * @param {string}      event
     * @param {function}    callback
     */

  }, {
    key: 'removeDelegatedEventListener',
    value: function removeDelegatedEventListener(target, event, callback) {
      if (typeof callback !== 'function') {
        throw new TypeError('callback must be a function');
      }

      if (!(target instanceof Element || target instanceof Window || target instanceof HTMLDocument)) {
        throw new TypeError('target must be window, document or an element');
      }

      this.delegatedEvents[event] = this.delegatedEvents[event].filter(function (item) {
        return !(item.target === target && item.callback === callback);
      });

      target.removeEventListener(event, callback);

      this.events['delegatedEventListeners:remove'].forEach(function (callback) {
        return callback();
      });
    }

    /**
     * Attach all delegated event listeners
     */

  }, {
    key: 'attachDelegatedEventListeners',
    value: function attachDelegatedEventListeners() {
      var _this2 = this;

      Object.keys(this.delegatedEvents).forEach(function (event) {
        var defs = _this2.delegatedEvents[event];
        defs.forEach(function (def) {
          def.target.addEventListener(event, def.callback, def.options);
        });
      });

      this.events['delegatedEventListeners:attach'].forEach(function (callback) {
        return callback();
      });
    }

    /**
     * Detach all delegated event listeners
     */

  }, {
    key: 'detachDelegatedEventListeners',
    value: function detachDelegatedEventListeners() {
      var _this3 = this;

      Object.keys(this.delegatedEvents).forEach(function (event) {
        var defs = _this3.delegatedEvents[event];
        defs.forEach(function (def) {
          def.target.removeEventListener(event, def.callback);
        });
      });

      this.events['delegatedEventListeners:detach'].forEach(function (callback) {
        return callback();
      });
    }

    /**
     * Detach event listeners from all items, and clear the list of listeners
     */

  }, {
    key: 'purgeDelegatedEventListeners',
    value: function purgeDelegatedEventListeners() {
      this.detachDelegatedEventListeners();
      this.delegatedEventListeners = {};

      this.events['delegatedEventListeners:purge'].forEach(function (callback) {
        return callback();
      });
    }

    /**
     * Create a MutationObserver instance to monitor the entire DOM,
     * and refresh the element when the node tree changes
     */

  }, {
    key: 'registerDOMObserver',
    value: function registerDOMObserver() {
      this.observer = new MutationObserver(this.refresh);

      this.resume();

      this.events.start.forEach(function (callback) {
        return callback();
      });
    }

    /**
     * Pause observation of the element's parent
     */

  }, {
    key: 'pause',
    value: function pause() {
      this.observer.disconnect();

      this.events.pause.forEach(function (callback) {
        return callback();
      });
    }

    /**
     * Resume observation of the element's parent
     */

  }, {
    key: 'resume',
    value: function resume() {
      if (this.parent) {
        this.observer.observe(this.parent, this.observerConfig);
      }

      this.events.resume.forEach(function (callback) {
        return callback();
      });
    }
  }]);

  return Observable;
}(), (_applyDecoratedDescriptor(_class.prototype, 'on', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'on'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'off', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'off'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'purgeEventListeners', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'purgeEventListeners'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'addDelegatedEventListener', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'addDelegatedEventListener'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeDelegatedEventListener', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'removeDelegatedEventListener'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'attachDelegatedEventListeners', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'attachDelegatedEventListeners'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'detachDelegatedEventListeners', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'detachDelegatedEventListeners'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'purgeDelegatedEventListeners', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'purgeDelegatedEventListeners'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'registerDOMObserver', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'registerDOMObserver'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'pause', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'pause'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resume', [_decko.bind], Object.getOwnPropertyDescriptor(_class.prototype, 'resume'), _class.prototype)), _class);
exports.default = Observable;
//# sourceMappingURL=observable.js.map